/*
 * @Descripttion: 提现审核列配置
 * @version:
 * @Author: Raoxf
 * @Date: 2025-01-XX
 */

const TRANSACTION_STATUS = {
  0: "提交申请",
  1: "处理中(同意)",
  2: "成功",
  3: "失败（拒绝）",
};

const TRANSACTION_TYPE = {
  1: "充值",
  2: "消费",
  3: "退款",
  4: "提现",
  5: "系统调整等",
  11: "服务订单",
  12: "广场订单",
  13: "打赏",
  14: "手机回收",
  15: "衣物回收",
};

export default (Vue) => {
  return [
    {
      title: "交易ID",
      key: "id",
      minWidth: 100,
      align: "center",
    },
    {
      title: "交易单号",
      key: "transactionNo",
      minWidth: 180,
      align: "center",
    },
    {
      title: "用户ID",
      key: "userId",
      minWidth: 100,
      align: "center",
    },
    {
      title: "交易类型",
      key: "transactionType",
      minWidth: 100,
      align: "center",
      render: (h, { row }) => {
        const text = TRANSACTION_TYPE[row.transactionType] || "-";
        return h("span", {}, text);
      },
    },
    {
      title: "交易金额",
      key: "amount",
      minWidth: 120,
      align: "center",
      render: (h, { row }) => {
        const amount = row.amount || 0;
        const color = amount < 0 ? "#f56c6c" : "#67c23a";
        return h("span", { style: { color } }, amount);
      },
    },
    {
      title: "余额",
      key: "balance",
      minWidth: 120,
      align: "center",
    },
    {
      title: "交易状态",
      key: "transactionStatus",
      minWidth: 120,
      align: "center",
      render: (h, { row }) => {
        const text = TRANSACTION_STATUS[row.transactionStatus] || "-";
        return h("span", {}, text);
      },
    },
    {
      title: "业务类型",
      key: "businessType",
      minWidth: 150,
      align: "center",
      render: (h, { row }) => {
        const text = row.businessType === "WITHDRAW" ? "提现中" : "其他";
        return h("span", {}, text);
      },
    },
    {
      title: "业务ID",
      key: "businessId",
      minWidth: 150,
      align: "center",
    },
    {
      title: "描述",
      key: "description",
      minWidth: 150,
      align: "center",
    },
    {
      title: "备注",
      key: "remark",
      minWidth: 150,
      align: "center",
    },
    {
      title: "创建时间",
      key: "createTime",
      minWidth: 180,
      align: "center",
    },
    {
      title: "更新时间",
      key: "updateTime",
      minWidth: 180,
      align: "center",
    },
    {
      title: "操作",
      key: "action",
      fixed: "right",
      align: "center",
      width: 200,
      render: (h, { row }) => {
        const buttons = [];

        // 只有状态为"提交申请"(0)或"处理中(同意)"(1)时才显示审核按钮
        if (row.transactionStatus === 0) {
          // 同意按钮
          buttons.push(
            h(
              "Button",
              {
                props: {
                  type: "text",
                  size: "small",
                },
                style: {
                  color: "#67c23a",
                  marginRight: "8px",
                },
                on: {
                  click: () => {
                    Vue.handleReview(row, 1); // 2表示成功
                  },
                },
              },
              "同意"
            )
          );

          // 拒绝按钮
          buttons.push(
            h(
              "Button",
              {
                props: {
                  type: "text",
                  size: "small",
                },
                style: {
                  color: "#f56c6c",
                  marginRight: "8px",
                },
                on: {
                  click: () => {
                    Vue.handleReview(row, 3); // 3表示失败（拒绝）
                  },
                },
              },
              "拒绝"
            )
          );
        }

        return h("div", buttons);
      },
    },
  ];
};
